"use client";
import React from "react";
import ActiveDatesSection from "@/components/coupon/activeDatesSection";
import BreadCrumbs from "@/components/coupon/breadCrumbs";
import DiscountMethodSection from "@/components/coupon/discountMethodSection";
import DiscountValueSection from "@/components/coupon/discountValueSection";
import SaveFreeShipping from "@/components/coupon/free-shipping/saveCoupon";
import MinimumPurchaseRequirements from "@/components/coupon/minimumPurchaseRequirements";

const FreeShippingPage = () => {
  return (
    <div className="coupon-page space-y-6">
      <BreadCrumbs page="Free Shipping" />
      <DiscountMethodSection currentPage="freeShipping" />
      <DiscountValueSection currentPage="freeShipping" />
      <div className="grid w-full grid-cols-[repeat(auto-fit,minmax(min(250px,100%),1fr))] gap-5">
        <MinimumPurchaseRequirements currentPage="freeShipping" />
        <ActiveDatesSection currentPage="freeShipping" />
      </div>
      <SaveFreeShipping currentPage="freeShipping" />
    </div>
  );
};

export default FreeShippingPage;
